<template>
  <div class="notification-schedule-cell" :data-testid="dataTestid">
    <span v-if="isTrigger">When it happens</span>
    <span v-else>{{ summary }}</span>
    <FcTooltip
      v-if="!isTrigger && resolvedSchedule"
      variant="rich"
      fixed
      eager
      transition="fade-transition"
      :open-delay="0"
      content-class="notification-schedule-cell__tooltip"
    >
      <v-icon small class="ml-1">mdi-help-circle-outline</v-icon>
      <template #content>
        <NotificationNextRunsTooltip :schedule="resolvedSchedule" />
      </template>
    </FcTooltip>
  </div>
</template>

<script>
import FcTooltip from '../../FcTooltip/FcTooltip.vue';
import NotificationNextRunsTooltip from '../NotificationNextRunsTooltip/NotificationNextRunsTooltip.vue';
import { describeSchedule, scheduleFromLegacyCron } from '../../../utils/notificationScheduleUtils';
import { NOTIFICATION_KIND } from '../../../utils/constants';

export default {
  name: 'NotificationScheduleCell',
  components: { FcTooltip, NotificationNextRunsTooltip },
  props: {
    schedule: { type: Object, default: () => ({}) },
    cron: { type: String, default: '' },
    nextRunAt: { type: String, default: '' },
    kind: { type: String, default: 'schedule' },
    dataTestid: { type: String, default: 'notification-schedule-cell' },
  },
  computed: {
    isTrigger() {
      return this.kind === NOTIFICATION_KIND.TRIGGER;
    },
    resolvedSchedule() {
      if (this.schedule && this.schedule.startTime) return this.schedule;
      return this.cron ? scheduleFromLegacyCron(this.cron) : null;
    },
    summary() {
      return this.resolvedSchedule ? describeSchedule(this.resolvedSchedule) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-schedule-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
  overflow: visible;
}
</style>
